import { ActionContext } from "vuex";
import axios from "@/plugins/axios";
import { AxiosResponse } from "axios";
import { get, set } from "@/utils/vuex";

export default {
  namespaced: true,
  state: (): any => ({
    loading: false,
    selectedCustomerId: "",
  }),
  getters: {
    getLoading: get("loading"),
    getSelectedCustomerId: get("selectedCustomerId"),
  },
  mutations: {
    setLoading: set("loading"),
    setSelectedCustomerId: set("selectedCustomerId"),
  },
  actions: {
    async createCustomer(
      context: ActionContext<any, any>,
      {
        metadata,
        name,
        description,
      }: { metadata: string; name: string; description: string }
    ): Promise<any> {
      const payload = { metadata, name, description };
      context.commit("setLoading", true);
      return axios
        .post(`/api/stripe/customer`, payload)
        .catch((error: AxiosResponse) => {
          context.commit("snackbar/toastError", error?.data || {}, {
            root: true,
          });
          return error;
        })
        .finally(() => {
          context.commit("setLoading", false);
        });
    },
    async updateCustomer(
      context: ActionContext<any, any>,
      { id, payload }: { id: string; payload: any }
    ): Promise<any> {
      context.commit("setLoading", true);
      return axios
        .patch(`/api/stripe/customer/${id}`, payload)
        .catch((error: AxiosResponse) => {
          context.commit("snackbar/toastError", error?.data || {}, {
            root: true,
          });
          return error;
        })
        .finally(() => {
          context.commit("setLoading", false);
        });
    },
    async fetchCustomer(
      context: ActionContext<any, any>,
      { id }: { id: string }
    ): Promise<any> {
      context.commit("setLoading", true);
      return axios
        .get(`/api/stripe/customer/${id}`)
        .catch((error: AxiosResponse) => {
          context.commit("snackbar/toastError", error?.data || {}, {
            root: true,
          });
          return error;
        })
        .finally(() => {
          context.commit("setLoading", false);
        });
    },
  },
};
